// extracted by mini-css-extract-plugin
module.exports = {"noteCon":"ratingAddNotes_noteCon__1R49E","textBox":"ratingAddNotes_textBox__CQxpc","btnSubmit":"ratingAddNotes_btnSubmit__3rO-s"};